module.exports = __webpack_public_path__ + "img/mc.f19f8266.jpg";